// extracted by mini-css-extract-plugin
export default {"others-header":"Header_others-header__S-IcN","others-header__buttons":"Header_others-header__buttons__Y32P-"};